import React, { useState } from 'react';
import { send } from 'emailjs-com';
import { toast, Toaster } from 'react-hot-toast';

function Support() {
    const [fromName, setFromName] = useState('');
    const [fromSucursal, setFromSucursal] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
  
    const handleFormSubmit = async (event) => {
      event.preventDefault();
      setIsLoading(true);
  
      const emailData = {
        from_name: fromName,
        from_sucursal: fromSucursal,
        message: message,
      };
  
      try {
        await send(
          'service_vkf6ppo',
          'template_a069aud',
          emailData,
          'l9vOGxqO0XfyH8Aog'
        );
        
        toast.success('¡Mensaje enviado exitosamente!');

        setFromName('');
        setFromSucursal('');
        setMessage('');
      } catch (error) {
        console.error('Error al enviar el mensaje:', error);
        toast.error('Error al enviar el mensaje. Por favor, intente nuevamente.');
      } finally {
        setIsLoading(false);
      }
    };
  
    return (
      <div style={containerStyle}>
        <Toaster />
        <h1 style={headingStyle}>Contacto de soporte</h1>
        <form onSubmit={handleFormSubmit} style={formStyle}>
          <div style={formFieldStyle}>
            <label htmlFor="fromName" style={labelStyle}>
              Nombre del cliente:
            </label>
            <input
              type="text"
              id="fromName"
              value={fromName}
              onChange={(event) => setFromName(event.target.value)}
              required
              style={inputStyle}
              disabled={isLoading}
            />
          </div>
          <div style={formFieldStyle}>
            <label htmlFor="fromSucursal" style={labelStyle}>
              Sucursal del cliente:
            </label>
            <input
              type="text"
              id="fromSucursal"
              value={fromSucursal}
              onChange={(event) => setFromSucursal(event.target.value)}
              required
              style={inputStyle}
              disabled={isLoading}
            />
          </div>
          <div style={formFieldStyle}>
            <label htmlFor="message" style={labelStyle}>
              Mensaje:
            </label>
            <textarea
              id="message"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              required
              style={textareaStyle}
              disabled={isLoading}
            />
          </div>
          <button 
            type="submit" 
            style={{
              ...buttonStyle,
              opacity: isLoading ? 0.7 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer'
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <span>
                <i className="fas fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                Enviando...
              </span>
            ) : (
              <span>
                <i className="fas fa-paper-plane" style={{ marginRight: '8px' }}></i>
                Enviar mensaje
              </span>
            )}
          </button>
        </form>
      </div>
    );
}
  
const containerStyle = {
    maxWidth: '960px',
    margin: '0 auto',
    padding: '2rem',
};
  
const formStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
    margin: '2rem auto',
    width: '100%',
    maxWidth: '800px',
    color: '#fff',
};
  
const formFieldStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
};
  
const labelStyle = {
    fontWeight: '500',
    color: '#eee',
    fontSize: '1.1rem',
};
  
const inputStyle = {
    padding: '10px 15px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    color: '#fff',
    fontSize: '1rem',
    transition: 'all 0.3s ease',
    '&:focus': {
        backgroundColor: 'rgba(255, 255, 255, 0.15)',
        borderColor: 'rgba(255, 255, 255, 0.3)',
    }
};
  
const textareaStyle = {
    ...inputStyle,
    gridColumn: '1 / -1',
    minHeight: '150px',
    resize: 'vertical',
    fontFamily: 'inherit',
};
  
const buttonStyle = {
    gridColumn: '1 / -1',
    justifySelf: 'center',
    padding: '12px 30px',
    border: 'none',
    borderRadius: '8px',
    backgroundColor: '#9400d3',
    color: '#fff',
    fontSize: '1.1rem',
    fontWeight: '500',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '200px',
    '&:hover': {
        backgroundColor: '#7b00b3',
        transform: 'translateY(-2px)',
    }
};
  
const headingStyle = {
    color: '#eee',
    fontSize: '2.5rem',
    marginBottom: '1rem',
    textAlign: 'center',
    fontWeight: '600',
};
  
export default Support;
  